export default function About() {
    return (
        <section id={"about"}>
            <h2 className={"section-header"}>About Kretz Coding</h2>
        </section>
    )
}